import Config from '../../config';
import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Script from '../../model/refbooks/script';
import ScriptForm from './scripts.form';
import Scripts from '../../collection/refbooks/scripts';

import { ask, } from '../../utils/popups';
import { restrict } from '../../model/actions';
import { roleA, roleAC, roleAI } from '../../roles';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/scripts.list',

    url() {
        return `scripts/list/${this.state().type.toLowerCase()}/${this.state().operation.toLowerCase()}`;
    },

    open() {
        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: restrict( roleAC, () => this.trigger( ScriptForm.NEW, 
                new Script( {
                    operation: this.state().operation !== 'ALL-OPS'
                        ? this.state().operation
                        : 'INSERT',
                    type: this.state().type !== 'ALL-TYPES'
                        ? this.state().type
                        : 'VALIDATION',
                    script: this.state().type === 'VALIDATION' || this.state().type === 'ALL-TYPES'
                        ? 'return valid()'
                        : 'return noop()',
                } ), 
                this.state().cluster ) ),
            
            edit: restrict( roleAC,
                
                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" scripts: with cluster == my cluster;
                    // there are only global and "my" types in the list;
                    // so, let's check only presence of cluster in sctipt
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },
                
                current => this.trigger( ScriptForm.EDIT,
                    current.clone() ) ),
            
            destroy: restrict( roleAC, 
                
                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" scripts: with cluster == my cluster;
                    // there are only global and "my" types in the list;
                    // so, let's check only presence of cluster in sctipt
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },
                
                current => {
                    const { page } = this.state();
                    // length will be updated by "destroy" call on model
                    const length = this.options.paged.length;

                    ask( 'script::modal delete - confirmation text',
                        'script::modal delete - title', 'actions::yes', 'actions::no',
                        () => this.options.source.destroy( current ) )
                        .then( () => {
                            if (length === 1 && page > 1)
                                    this.setState( { page: page - 1, } );
                        } )
                        .then( () => this.sort() )
                        .then( () => this.render() )
                        .then( () => this.navigated() ) 
                } ),
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )
        this.options.source = new Scripts( this.options.scripts.models );
        this.options.sorted = new Scripts();
        this.options.filtered = new Scripts();
        this.options.paged = new Scripts( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

    filterFn(model) {
        const { operation, type } = this.state();

        return (operation === 'ALL-OPS' || model.get( 'operation' ) === operation)
            && (type === 'ALL-TYPES' || model.get( 'type' ) === type);
    },

    serialize() {
        const context = RefBooksList.prototype.serialize.call( this );

        const { workgroups, } = this.options;
        const workgroupsAltered = workgroups.toJSON()
            .filter( model => model.defaults )
            .map( ({ id, organization: { name } }) => ({ id, name }) );

        const { sort, direction, search: searchString, operation, type, } = this.state();
        this.filter();
        
        return {
            ...context,
            workgroups: workgroupsAltered,
            actionList: this.options.paged.actions,
            collection: this.options.paged,
            sort, direction,
            searchString,
            operation, type,
        };
    },

    [RefBooksList.event( 'op:toggle' )](operation) {
        return this.setState( { page: 1, operation, } ),
            this.render().then( () => this.navigated() );
    },

    [RefBooksList.event( 'type:toggle' )](type) {
        return this.setState( { page: 1, type, } ),
            this.render().then( () => this.navigated() );
    },


} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/scripts.list.js